import {getCountries, getCountryCallingCode} from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
class Countries {
  static get options() {
    if (!Boolean(this.countriesOptions)) {
      this.countriesOptions = getCountries().map((country) => ({
        code: getCountryCallingCode(country),
        flag: flags[country]({title: country}),
        country
      }));
    }
    return this.countriesOptions;
  }
}
export default Countries;
